module.exports = __webpack_public_path__ + "img/ep3-7.75e2d175.png";